import './header-drawer.js';

class PaLazyHeaderDrawer extends HTMLElement {
  #loadingPromise = null;

  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.querySelector('button')?.removeEventListener('click', this.#handleClick);
  }

  #handleClick = () => {
    this.#loadAndOpen();
  };

  async #loadAndOpen() {
    if (this.#loadingPromise) return this.#loadingPromise;

    const button = this.querySelector('button');
    const sectionId = this.dataset.sectionId;
    if (!button || !sectionId) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    this.#loadingPromise = this.#fetchDrawer(sectionId);

    try {
      const drawerRoot = await this.#loadingPromise;
      this.replaceWith(drawerRoot);
      await customElements.whenDefined('header-drawer');

      requestAnimationFrame(() => {
        drawerRoot.querySelector('summary')?.click();
      });
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      this.#loadingPromise = null;
      console.error('Unable to load the mobile menu.', error);
    }
  }

  async #fetchDrawer(sectionId) {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    const response = await fetch(url, {
      headers: {
        Accept: 'text/html',
      },
    });

    if (!response.ok) {
      throw new Error(`Mobile menu request failed with status ${response.status}`);
    }

    const markup = await response.text();
    const parsedDocument = new DOMParser().parseFromString(markup, 'text/html');
    const drawerRoot = parsedDocument.querySelector('[data-pa-mobile-menu-root]');

    if (!(drawerRoot instanceof HTMLElement)) {
      throw new Error('Mobile menu markup was not found.');
    }

    for (const [index, style] of parsedDocument.querySelectorAll('style').entries()) {
      const styleKey = `${sectionId}-${index}`;

      const existingStyle = document.head.querySelector(`style[data-pa-lazy-menu-style="${styleKey}"]`);

      if (existingStyle) continue;

      const importedStyle = document.createElement('style');
      importedStyle.dataset.paLazyMenuStyle = styleKey;
      importedStyle.textContent = style.textContent;
      document.head.append(importedStyle);
    }

    return drawerRoot;
  }
}

if (!customElements.get('pa-lazy-header-drawer')) {
  customElements.define('pa-lazy-header-drawer', PaLazyHeaderDrawer);
}
